import { h } from "preact";

import DropdownMenu from "../v2/DropdownMenu";
import Menu from "../v2/Menu";

interface Props<T = unknown>{
    id: string;
    class?: string;
    buttonClass?: string;
    name?: string;
    value: T;
    options: {name: string; value: T;}[];
    dropdownOptions?: {top: number; left: number;};
    onChange: (name: string, value: T) => void;
}

export default function Picker<T>({
    id, class: cssClass, buttonClass, name, value, options, onChange
}: Props<T>) {
    function createChangeHandler(newValue:T) {
        return () => {
            onChange(id, newValue);
        };
    }

    function getPickerItems() {
        return options.map(option => (
            <Menu.Button
                key={option.value}
                checked={option.value === value}
                onClick={createChangeHandler(option.value)}>
                {option.name}
            </Menu.Button>
        ));
    }

    return (
        <DropdownMenu
            class={cssClass}
            buttonProps={{
                class: buttonClass,
                textClass: "caption-2 semibold",
                children: name
            }}>
            {getPickerItems()}
        </DropdownMenu>
    );
}
